import React from 'react';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import useStyles from './useStyles';
import UberLogo from './assets/Uber';
import AdidasLogo from './assets/Adidas';
import ClickUpLogo from './assets/ClickUp';
import HarvardLogo from './assets/Harvard';
import KelloggsLogo from './assets/Kelloggs';
import COPY from './copy';

export default function SocialProof(): JSX.Element {
  const { Logos, SocialProofContainer, TrustedBy } = useStyles();

  return (
    <Box className={SocialProofContainer}>
      <div className={TrustedBy}>{t(COPY.SOCIAL_PROOF)}</div>
      <Box className={Logos}>
        <UberLogo />
        <AdidasLogo />
        <ClickUpLogo />
        <HarvardLogo />
        <KelloggsLogo />
      </Box>
    </Box>
  );
}
